$( document ).ready(function() {

		$('#package-gallery').easyResponsiveTabs({
			type: 'default',
			width: 'auto',
			fit: true,
			closed: 'accordion',
			activate: function(event) {
			  var $tab = $(this);
			  var $info = $('#tabInfo');
			  var $name = $('span', $info);
			  $name.text($tab.text());
			  $info.show();
			}
		  });

		function activateTabFromParam() {
			var params = new URLSearchParams(window.location.search);
			var tabId = params.get('tab');
			if (!tabId) return;

			var $packageGallery = $('#package-gallery');
			var $tabItem = $packageGallery.find('li[data-tab="' + tabId + '"]');

			if (!$tabItem.length) return;

			if (!$tabItem.hasClass('resp-tab-active')) {
				$tabItem.trigger('click');
			}

			setTimeout(function () {
				var headerHeight = $('.mainheader').outerHeight() || 0;
				var elementTop = $packageGallery[0].getBoundingClientRect().top + $(window).scrollTop();
				var targetOffset = elementTop - headerHeight - 20;

				$('html, body').animate({
					scrollTop: targetOffset
				}, 300);
			}, 100);
		}

		activateTabFromParam();

		var perPage = 10;

		$('.tab_content').each(function () {
			var $tabContent = $(this);
			var $items = $tabContent.find('.grid-item');
			var $btn = $tabContent.find('.gallery-load-more');
			var visible = perPage;

			function updateVisibility() {
				$items.hide().slice(0, visible).show();
				$btn.toggle(visible < $items.length);
			}

			if (!$items.length || $items.length <= perPage) {
				$btn.hide();
				return;
			}

			updateVisibility();

			$btn.on('click', function () {
				visible += perPage;
				updateVisibility();
			});
		});

});
